export let CPSPaymentTabs = [
    //   {
    //     label: '缴费内容',
    //     type: 'input',
    //     value: 'payContent',
    //     clearable: true
    //   },
    //   {
    //     label: '分公司',
    //     type: 'select',
    //     value: 'company',
    //     options: [],
    //     clearable: true
    //   },
    {
      label: '缴费时间',
      type: 'time-slot',
      startName: 'payDateStart', // 返回数据时，开始时间的字段名
      endName: 'payDateEnd', // 返回数据时，结束时间的字段名
      value: 'paymetTime'
    },
    {
      label: '缴费金额',
      clearable: true,
      type: 'price-slot',
      minName: 'payAmountStart',
      maxName: 'payAmountEnd',
      value: 'payAmount'
    }
  ]
  // 表格头
export let cpsPaymentTableLabels = [{
    label: '编号',
    value: 'serialCode'
  },
  {
    label: '母亲姓名',
    value: 'name'
  },
  {
    label: '母亲身份证号',
    value: 'idCard'
  },
  {
    label: '手机号',
    value: 'phone'
  },
  //   {
  //     label: '生日',
  //     value: 'birth_date'
  //   },
  {
    label: 'CPS合同号',
    value: 'contractNumber'
  },
  {
    label: '缴费内容',
    value: 'payContent'
  },
  {
    label: '缴费金额（元）',
    value: 'amount'
  },
  {
    label: '支付方式',
    value: 'pay_channel'
  },
  {
    label: '流水号',
    value: 'payOrderSerial'
  },
  {
    label: '分公司',
    value: 'company'
  },
  {
    label: '缴费时间',
    value: 'pay_date'
  },
  {
    label: "代付人",
    value: "otherUserName"
  },
  {
    label: "代付人手机号",
    value: "otherUserMobile"
  }
]